import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './Header.m.css';
import { ActiveLink } from '@dojo/framework/routing/ActiveLink';
import { Link } from '@dojo/framework/routing/Link';
import LearnMore from './LearnMore';
const sitepenLogo = require('../assets/images/SitePenLogo_Light.svg');
const chevronRightIcon = require('../assets/images/icons/chevron-right.svg');
const arrowRightIcon = require('../assets/images/icons/arrow-right.svg');
import router from '../middleware/router';

const factory = create({ router });

export const Header = factory(function Header({ middleware: { router } }) {
	return (
		<header id="site-header" classes={css.root}>
			<div classes={css.wrapper}>
				<input id="menuToggle" classes={css.menuToggleInput} type="checkbox" />
				<Link to="home" classes={[css.homeLink, css.gridLogo]} title="Home">
					<img loading="lazy" src={sitepenLogo} alt="Sitepen Logo" />
				</Link>
				<label classes={[css.menuToggleLabel, css.gridMenuToggle]} for="menuToggle">
					<span classes={css.srOnly}>Menu</span>
					<div classes={css.toggleBar} />
				</label>
				<nav classes={[css.nav, css.gridContent]}>
					<ul id="site-header-links" classes={css.links}>
						<li classes={[css.item]}>
							<span tabindex="0" classes={['headerLink', css.link]}>
								<span>What We Do</span>
								<img
									classes={['headerChevronRight', css.mobileChevron]}
									src={chevronRightIcon}
									alt=""
								/>
							</span>
							<div classes={css.dropdown}>
								<div classes={css.dropdownContentWrapper}>
									<div classes={['headerBackButton', css.backButton]}>
										<img
											classes={css.backButtonChevron}
											src={chevronRightIcon}
											alt=""
										/>
										<span classes={css.backButtonLabel}>Back</span>
									</div>
									<LearnMore
										title="What we do"
										content="Our cross-functional teams understand your business and partner with companies to define and incorporate strategy, design, and technology into all aspects of their product."
										link="services"
									/>
									<ul classes={css.linkDropdownList}>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Enterprise Software Development
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														to="servicesEnterpriseSoftwareDevelopment"
														tabindex="0"
													>
														<span classes={css.headingLink}>
															Enterprise Development Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesCustomSoftwareDevelopment"
													>
														Custom Software Development
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesWebApplicationDevelopment"
													>
														Web Application Development
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesCrossPlatformDevelopment"
													>
														Cross-Platform Development
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Enterprise Architecture
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseArchitecture"
													>
														<span classes={css.headingLink}>
															Enterprise Architecture Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesSoftwareArchitecture"
													>
														Architecture Design
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Enterprise UX Design
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseUX"
													>
														<span classes={css.headingLink}>
															Enterprise UX Design Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesRapidPrototyping"
													>
														Rapid Prototyping
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesUIDesign"
													>
														User Interaction Design
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesUXDesign"
													>
														User Experience Design
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Cloud Services
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseCloudServices"
													>
														<span classes={css.headingLink}>
															Cloud Services Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<a
														classes={['navLink', css.submenuLink]}
														href={router.link(
															'servicesEnterpriseCloudServices',
															{ hash: 'strategy-adoption' }
														)}
														tabindex="0"
													>
														Cloud Strategy & Adoption
													</a>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<a
														classes={['navLink', css.submenuLink]}
														href={router.link(
															'servicesEnterpriseCloudServices',
															{ hash: 'architecture-design' }
														)}
														tabindex="0"
													>
														Cloud Architecture Design
													</a>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<a
														classes={['navLink', css.submenuLink]}
														href={router.link(
															'servicesEnterpriseCloudServices',
															{ hash: 'enterprise-cloud-integration' }
														)}
														tabindex="0"
													>
														Enterprise Cloud Integration
													</a>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<a
														classes={['navLink', css.submenuLink]}
														href={router.link(
															'servicesEnterpriseCloudServices',
															{ hash: 'migration-management' }
														)}
														tabindex="0"
													>
														Cloud Migration Management
													</a>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Process & Technical Strategy
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseTechnologyStrategy"
													>
														<span classes={css.headingLink}>
															Strategy Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesSoftwareModernization"
													>
														Legacy Software Modernization
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseDevOpsSolutions"
													>
														DevOps Services &amp; Solutions
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Quality Assurance
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesQualityAssurance"
													>
														<span classes={css.headingLink}>
															Quality Assurance Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesAutomatedTesting"
													>
														Automated Testing
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesPerformanceTesting"
													>
														Performance Analysis
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesPerformanceOptimization"
													>
														Performance Optimization
													</Link>
												</li>
											</ul>
										</li>
									</ul>
								</div>
							</div>
						</li>
						<li classes={[css.item]}>
							<span tabindex="0" classes={['headerLink', css.link]}>
								<span>Our Work</span>
								<img
									classes={['headerChevronRight', css.mobileChevron]}
									src={chevronRightIcon}
									alt=""
								/>
							</span>
							<div classes={css.dropdown}>
								<div classes={css.dropdownContentWrapper}>
									<div classes={['headerBackButton', css.backButton]}>
										<img
											classes={css.backButtonChevron}
											src={chevronRightIcon}
											alt=""
										/>
										<span classes={css.backButtonLabel}>Back</span>
									</div>
									<LearnMore
										title="Our Work"
										content="From proofs-of-concept to fullstack feature development to legacy re-engineering, companies rely on our agility and expertise in all areas of the software development lifecycle."
										link="work"
									/>
									<ul classes={css.linkDropdownList}>
										<li classes={css.dropdownLinkWrapper}>
											<Link
												classes={['navLink', css.submenuLink]}
												tabIndex={0}
												to="casestudyFannie"
											>
												Case Study - Fannie Mae
											</Link>
										</li>
										<li classes={css.dropdownLinkWrapper}>
											<Link
												classes={['navLink', css.submenuLink]}
												tabIndex={0}
												to="casestudyMarriott"
											>
												Case Study - Marriott
											</Link>
										</li>
										<li classes={css.dropdownLinkWrapper}>
											<Link
												classes={['navLink', css.submenuLink]}
												tabIndex={0}
												to="casestudyBuilt"
											>
												Case Study - Built
											</Link>
										</li>
										<li classes={css.dropdownLinkWrapper}>
											<Link
												classes={['navLink', css.submenuLink]}
												tabIndex={0}
												to="casestudyCentric"
											>
												Case Study - Centric
											</Link>
										</li>
										<li classes={css.dropdownLinkWrapper}>
											<Link
												classes={['navLink', css.submenuLink]}
												tabIndex={0}
												to="casestudySocialTripWizard"
											>
												Case Study - Social Knowledge
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</li>
						<li classes={[css.item]}>
							<span tabindex="0" classes={['headerLink', css.link]}>
								<span>Expertise</span>
								<img
									classes={['headerChevronRight', css.mobileChevron]}
									src={chevronRightIcon}
									alt=""
								/>
							</span>
							<div classes={[css.dropdown]}>
								<div classes={css.dropdownContentWrapper}>
									<div classes={['headerBackButton', css.backButton]}>
										<img
											classes={css.backButtonChevron}
											src={chevronRightIcon}
											alt=""
										/>
										<span classes={css.backButtonLabel}>Back</span>
									</div>
									<LearnMore
										title="Expertise"
										content="Our project teams create enterprise-grade tools and technologies based on our experience developing mission-critical applications for companies worldwide."
										link="expertise"
									/>
									<ul classes={css.linkDropdownList}>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Our Capabilities
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="services"
													>
														<span classes={css.headingLink}>
															Overview of Our Capabilities
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseFullStack"
													>
														Full-Stack JavaScript Development
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseUX"
													>
														UI | UX Design
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseArchitecture"
													>
														Web Architecture
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesQualityAssurance"
													>
														Quality Assurance / Testing
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="servicesEnterpriseDevOpsSolutions"
													>
														DevOps
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>Technology</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.dropdownLabel}>Javascript</li>
												<li
													classes={[
														css.submenuLinkWrapper,
														css.iconLabel
													]}
												>
													<img
														classes={css.arrowRightIcon}
														loading="lazy"
														src={arrowRightIcon}
														alt="approach icon"
													/>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseFullStack"
													>
														Full-stack JavaScript
													</Link>
												</li>
												<li
													classes={[
														css.submenuLinkWrapper,
														css.iconLabel
													]}
												>
													<img
														classes={css.arrowRightIcon}
														loading="lazy"
														src={arrowRightIcon}
														alt="approach icon"
													/>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseNode"
													>
														Server-side Javascript
													</Link>
												</li>
												<li classes={css.dropdownLabel}>Typescript</li>
												<li
													classes={[
														css.submenuLinkWrapper,
														css.iconLabel
													]}
												>
													<img
														classes={css.arrowRightIcon}
														loading="lazy"
														src={arrowRightIcon}
														alt="approach icon"
													/>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseTypeScript"
													>
														Full-stack Typescript
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Frameworks & Tools
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={[css.submenuLinkWrapper]}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseTypeScript"
													>
														Typescript
													</Link>
												</li>
												<li classes={[css.submenuLinkWrapper]}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseAngular"
													>
														Angular
													</Link>
												</li>
												<li classes={[css.submenuLinkWrapper]}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseReact"
													>
														React
													</Link>
												</li>
												<li classes={[css.submenuLinkWrapper]}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseDojo"
													>
														Dojo
													</Link>
												</li>
												<li classes={[css.submenuLinkWrapper]}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="expertiseVue"
													>
														Vue
													</Link>
												</li>
											</ul>
										</li>
										<li classes={css.linkDropdown}>
											<span
												tabindex="0"
												classes={['navLink', css.submenuLink]}
											>
												<span classes={[css.submenuLabel]}>
													Open Source Development
												</span>
												<img
													classes={[
														'headerChevronRight',
														css.chevronRight
													]}
													src={chevronRightIcon}
													alt=""
												/>
											</span>
											<ul classes={[css.submenu]}>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="opensource"
													>
														<span classes={css.headingLink}>
															OS Development Overview
														</span>
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="opensourceDojo"
													>
														Dojo Framework
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="opensourceDojoToolkit"
													>
														Dojo Toolkit
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="opensourceDgrid"
													>
														Dgrid
													</Link>
												</li>
												<li classes={css.submenuLinkWrapper}>
													<Link
														classes={['navLink', css.submenuLink]}
														tabIndex={0}
														to="opensourceIntern"
													>
														Intern
													</Link>
												</li>
											</ul>
										</li>
									</ul>
								</div>
							</div>
						</li>
						<li classes={css.item}>
							<ActiveLink classes={css.link} to="blog" activeClasses={[css.active]}>
								<span>Insights</span>
								<img
									classes={['headerChevronRight', css.mobileChevron]}
									src={chevronRightIcon}
									alt=""
								/>
							</ActiveLink>
						</li>
						<li classes={css.item}>
							<ActiveLink
								classes={css.link}
								to="contact"
								activeClasses={[css.active]}
							>
								<span>Contact</span>
								<img
									classes={['headerChevronRight', css.mobileChevron]}
									src={chevronRightIcon}
									alt=""
								/>
							</ActiveLink>
						</li>
					</ul>
				</nav>
			</div>
		</header>
	);
});

export default Header;
